import _ from 'lodash';
import React, {PropTypes} from 'react';
import classnames from 'classnames';

import './styles';



export default class Selections extends React.Component {

  static propTypes = {
    selectStyle: PropTypes.object,
    selectionsStyle: PropTypes.object,
  }

  static defaultProps = {
    selectStyle: {
      "backgroundImage": "url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iN3B4IiBoZWlnaHQ9IjExcHgiIHZpZXdCb3g9IjAgMCA3IDExIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0MiAoMzY3ODEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPnVwLWRvd24tZHJvcGRvd248L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iR3JhcGhpY3MiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJhZGQtZHJvcGRvd25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTExLjAwMDAwMCwgLTE4MC4wMDAwMDApIiBmaWxsPSIjODA4Qjk2Ij4KICAgICAgICAgICAgPGcgaWQ9InVwLWRvd24tZHJvcGRvd24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMS4wMDAwMDAsIDE4MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0zIj4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0xIiBwb2ludHM9IjAgNi4xMjUgNyA2LjEyNSAzLjUgMTAuNSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTIiIHBvaW50cz0iNyA0LjM3NSAwIDQuMzc1IDMuNSAwIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==')"
    },
    selectionsStyle: {},
  }

  render() {
    return (
      <div className={classnames({fluid: this.props.fluid}, 'Selections')} style={this.props.selectionsStyle}>

        <select
          className={classnames('ui selection dropdown', this.props.className, {fluid: this.props.fluid})}
          value={this.props.value}
          name={this.props.name}
          onChange={this.props.onChange}
          ref="select"
          style={this.props.selectStyle}
          >
            {(!this.props.noDefault || this.props.value === '') && <option value="" disabled={true}>{this.props.defaultText || 'Select'}</option>}
            {_.map(this.props.selections, (selection) => {
              let value = selection.value || selection;
              let display = selection.display || value;
              return <option value={value} key={value}>{display}</option>;
            })}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/sp-components/components/Selections/index.jsx